import { keyBy } from "lodash";
import { axios } from "../connection/ConnectionHandler";
import {
  SET_PROJECT_CONTROL_LIST,
  SHOW_NOTIFICATION,
  UPDATE_PROJECT_CONTROL,
} from "../constants";

const formatProjectControl = (item) => ({
  ...item,
  label: item.name || item.erpProjectNo,
  value: item._id,
});

const formatProjectControls = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data.map(formatProjectControl);
  return formatProjectControl(data);
};

export const fetchProjectControls = () => async (dispatch) => {
  try {
    const response = await axios.get("/project-control");
    const formattedData = formatProjectControls(response.data);

    dispatch({
      type: SET_PROJECT_CONTROL_LIST,
      payload: keyBy(formattedData, "_id"),
    });

    return response.status;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const upsertProjectControl = (erpProjectNo, data) => async (dispatch) => {
  try {
    const response = await axios.put(
      `/project-control/${encodeURIComponent(erpProjectNo)}`,
      data
    );
    const formattedData = formatProjectControl(response.data);

    dispatch({ type: UPDATE_PROJECT_CONTROL, payload: formattedData });
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: {
        show: true,
        status: "info",
        message: "Control de proyecto actualizado.",
      },
    });

    return response.status;
  } catch (err) {
    console.error(err);
    return err;
  }
};
